// Lightweight, fire-and-forget visitor analytics. Beacons page/activity dwell
// time to the backend so the marketing dashboard can show what visitors do and
// how long they spend on each page/activity. No PII is sent — only the route
// path, a duration, and the surface.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// Routes that represent a learning ACTIVITY rather than a plain page.
const ACTIVITY_PREFIXES = [
  '/reading', '/quiz', '/flashcards', '/writing', '/memory',
  '/conversation', '/class', '/learn', '/review',
];

export function pathKind(path) {
  const p = String(path || '');
  return ACTIVITY_PREFIXES.some((prefix) => p === prefix || p.startsWith(`${prefix}/`))
    ? 'activity'
    : 'page';
}

// Send a dwell sample. Uses sendBeacon so it survives navigation/tab-close; falls
// back to fetch(keepalive). Never throws.
export function trackPageDwell(path, durationMs, kind) {
  try {
    if (!path || !(durationMs > 0)) return;
    const payload = JSON.stringify({
      path,
      durationMs: Math.round(durationMs),
      kind: kind || pathKind(path),
      source: 'web',
    });
    const url = `${API_URL}/analytics/page`;
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(() => {});
  } catch (_) { /* analytics must never break the app */ }
}
